import React from 'react';
import clsx from 'clsx';

import CompanyLogo from '../../../company-logo/CompanyLogo';
import CommonTooltipEllipses from '../../../common-tooltip-ellipses/CommonTooltipEllipses';

import scss from './HorizontalBars.module.scss';

function HorizontalBarsLabels({ data }) {
  return (
    <div className={scss.scalesWrapper}>
      {data.map((domainEntree, index) => (
        <div className={scss.scaleItem} key={`${domainEntree.label}-${index}`}>
          <span
            className={clsx(
              scss.scaleItemRankLabel,
              scss.scaleItemLabel,
              domainEntree.inFocus && scss.scaleItemLabelFocused,
              domainEntree.myCompany && scss.scaleItemLabelGreen,
            )}>
            {domainEntree.rank}
          </span>
          <CompanyLogo logo={domainEntree.companyLogo} size={24} />
          <CommonTooltipEllipses
            toolTipText={domainEntree.domain}
            label={domainEntree.label || domainEntree.domain}
            className={clsx(
              scss.scaleItemLabel,
              domainEntree.inFocus && scss.scaleItemLabelFocused,
              domainEntree.myCompany && scss.scaleItemLabelGreen,
            )}
            maxRows={2}
          />
        </div>
      ))}
    </div>
  );
}

export default HorizontalBarsLabels;
